import {
    type SetForgottenPasswordResponseType,
    type SetForgottenPasswordRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const SetForgottenPassword = async (params: SetForgottenPasswordRequestType): Promise<SetForgottenPasswordResponseType> => {
    return await axios(`${SERVER_ADDRESS}/authentication/setForgottenPassword`, {
        method: "PUT",
        headers: getHeaders(),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default SetForgottenPassword;
